// extracted by css-extract-rspack-plugin
export default {"banner":"GevxRI3HP0w6lIcr","label":"vI8ydkRl0Wki2iG8","statusBadge":"nrZrdoOkzuEaU7rZ","checkingIcon":"MxkEWZKmjYWh7xnG","errorIcon":"lP2RcbFXQXEO_ZOs"};